import React from 'react';
import FacturesPage from '../components/FacturesPage';
import * as api from '../api';

export default function FacturesAchat() {
  return (
    <FacturesPage
      title="Factures Fournisseurs"
      fetchFn={api.getFacturesAchatPage}
      getPdfFn={api.getFactureAchatPdf}
      onRefreshFn={api.syncOdooAchats}
      clientLabel="Fournisseur"
      getDocumentOrigine={f => ({
        label: f.achat_numero || '—',
        href:  f.achat_id ? `/achats?open_achat=${f.achat_id}` : null,
      })}
    />
  );
}
